// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"96":"b3a1b3ef8606a38c","105":"0cbbd357419e1a5e","175":"6b809c9c8cb6ac22"}[chunkId] + ".js";
};